import type ErrorData from 'sharedreact/data/ErrorData';
import ConnectionSupport from 'sharedreact/utils/ConnectionSupport';

type OnFetchSuccess = (data: {isAEOnPremises: boolean, isAESaaS: boolean, isAEPS2: boolean, isFlexoTools: boolean}) => void;
type OnFetchError = (error: ErrorData) => void;

function fetch (onSuccess: OnFetchSuccess, onError: OnFetchError): void {
  ConnectionSupport.post(
    'getServerInfo',
    {},
    onSuccess,
    onError
  );
}

const ServerInfoConnection = {
  fetch
};

export default ServerInfoConnection;